/* eslint-disable no-console */
import React, { Component } from 'react';
import _get from 'lodash.get';
import '../styles/_player-resizer.scss';

const OUTSIDE_CONTROLS_HEIGHT = 116;
const ASPECT_RATIO_COEFFICIENT = 1 / 0.5625;
















class PlayerResizer extends Component {














  constructor() {
    super();

    this.state = {
      calculatedMaxWidth: 0
    };
  }

  componentDidMount() {
    if (!this._containerRef) return;

    this._lastWidth = null;
    this._isCalculating = false;

    this._resizeObserver = new ResizeObserver(() => {
      this._scheduleCalculation();
    });

    this._resizeObserver.observe(this._containerRef);
    this._setResizingState(true);
  }

  componentWillUnmount() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }

    if (this._rafId) {
      cancelAnimationFrame(this._rafId);
      this._rafId = null;
    }

    if (this._resizeTimeoutId) {
      clearTimeout(this._resizeTimeoutId);
      this._resizeTimeoutId = null;
    }

    this._lastWidth = null;
    this._isCalculating = false;
  }

  _scheduleCalculation = () => {
    if (this._rafId) return;

    this._rafId = requestAnimationFrame(() => {
      this.calculateMaxWidth();
      this._rafId = null;
    });
  };

  calculateMaxWidth = () => {
    if (this._isCalculating) return;
    this._isCalculating = true;

    const { controlsOutside, isFullscreen } = this.props;

    if (!this._containerRef) {
      this._isCalculating = false;
      return;
    }

    const containerHeight = _get(this._containerRef, 'offsetHeight', 0);
    const controlsHeightAdjustment = controlsOutside && !isFullscreen ?
    OUTSIDE_CONTROLS_HEIGHT : 0;

    const rawCalculatedWidth = (containerHeight - controlsHeightAdjustment) *
    ASPECT_RATIO_COEFFICIENT;
    const widthValue = Math.floor(rawCalculatedWidth);

    if (!containerHeight || containerHeight <= controlsHeightAdjustment) {
      this.setState({ calculatedMaxWidth: '100%' }, () => {
        this._isCalculating = false;
      });
      return;
    }

    console.log('this._lastWidth', this._lastWidth);
    console.log('Calculated max width:', widthValue);

    // adding a small tolerance of 2 for container width and player width difference
    // $FlowFixMe
    if (this._lastWidth !== null && Math.abs(this._lastWidth - widthValue) <= 2) {
      this._isCalculating = false;
      return;
    }

    this._lastWidth = widthValue;

    const calculatedMaxWidth = `${widthValue}px`;

    this._setResizingState(true);

    this.setState({ calculatedMaxWidth }, () => {
      this._isCalculating = false;
      this._scheduleResizingStateReset();
    });
  };

  _setResizingState = (isResizing) => {
    if (this._innerDivRef) {
      this._innerDivRef.setAttribute('data-resizing', isResizing ? 'true' : 'false');
    }
  };

  _scheduleResizingStateReset = () => {
    if (this._resizeTimeoutId) {
      clearTimeout(this._resizeTimeoutId);
    }
    this._resizeTimeoutId = setTimeout(() => {
      this._setResizingState(false);
      this._resizeTimeoutId = null;
    }, 200);
  };

  setContainerRef = (containerRef) => {
    if (!containerRef || this._containerRef === containerRef) return;
    this._containerRef = containerRef;
    this._scheduleCalculation();
  };

  setInnerDivRef = (innerDivRef) => {
    this._innerDivRef = innerDivRef;
  };

  render() {
    const { children, resizable, minWidth, minHeight, standardVideo, isAnonymous } = this.props;
    const { calculatedMaxWidth } = this.state;

    if (!resizable) {
      return children;
    }

    const minWidthStyle = minWidth !== undefined ? `${minWidth}px` : undefined;
    const minHeightStyleForUser = isAnonymous ? 'calc(100vh - 300px)' : 'calc(100vh - 400px)';
    const minHeightStyle = minHeight !== undefined ? `${minHeight}px` : undefined;
    const finalMinHeight = standardVideo ? minHeightStyleForUser : minHeightStyle;

    return (
      <div className="player-resizer" style={{ minWidth: minWidthStyle, minHeight: finalMinHeight }}>
        <div ref={this.setContainerRef} className="player-resizer__container">
          <div ref={this.setInnerDivRef} data-resizing="false" style={{ maxWidth: calculatedMaxWidth }}>
            {children}
          </div>
        </div>
      </div>);

  }
}

export default PlayerResizer;